export default __webpack_public_path__ + "4aab76498c57ac384f95a5f4015d0f26.png";